import { Sector } from '@/domain/impact/impact.entity';
import {
  BeverageType,
  BeverageTypeValues,
  Category,
  ImpactCo2Answer,
  ValuesCateringBeverage,
} from '@/domain/impact-co2/entities/question.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { ImportedRow } from '../convert-excel-to-impact-answers';
import { buildBaseAnswer } from './common/build-base-answer';
import {
  filterRowsByCategory,
  filterRowsBySectors,
} from './common/filter-rows-by-category';
import { ImportMappingError } from './common/import-mapping.error';

const CATEGORY: Category = 'CATERING_BEVERAGE';
const SECTORS: Sector[] = ['TEAM', 'ARTISTS', 'PUBLIC'];

export function mapToCateringBeverageAnswers(
  rows: ImportedRow[],
): ImpactCo2Answer<ValuesCateringBeverage>[] {
  return rows
    .filter(filterRowsByCategory(CATEGORY))
    .filter(filterRowsBySectors(SECTORS))
    .map((row) => buildAnswer(row));
}

function buildAnswer(row: ImportedRow) {
  const beverageType = mapToBeverageType(row);
  const beverageCount = mapToBeverageCount(row);
  const baseAnswer = buildBaseAnswer(row, CATEGORY);
  const answer = {
    ...baseAnswer,
    values: {
      ...baseAnswer.values,
      beverageType,
      beverageCount,
    },
  };
  return answer;
}

function mapToBeverageType(row: ImportedRow): BeverageType {
  const tgsValue = row['Fairly Sub Category Description'];
  const result = validateValueInType<BeverageType>(
    tgsValue,
    BeverageTypeValues,
  );
  if (!result) {
    throw new ImportMappingError('beverageType', tgsValue, row);
  }
  return result;
}

function mapToBeverageCount(row: ImportedRow): number {
  const tgsValue = row['Volume (L)'];
  const result = parseInt(tgsValue, 10); // TODO : see how to handle 1.5L
  if (isNaN(result)) {
    throw new ImportMappingError('beverageCount', tgsValue, row);
  }
  return result;
}
